module.exports = __webpack_public_path__ + "static/media/mobile03.fefcd88d.jpg";